import { ReactNode, useState, useRef } from "react";
import { useClickAway } from "react-use";
import { useNotifications } from "@/modules/Notifications/hooks/useNotifications";

interface NotificationPopoverProps {
  trigger: ReactNode;
  children: ReactNode;
}

export function NotificationPopover({
  trigger,
  children,
}: NotificationPopoverProps) {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef(null);
  const { markAllAsRead } = useNotifications();

  useClickAway(popoverRef, () => {
    if (isOpen) {
      setIsOpen(false);
      markAllAsRead();
    }
  });

  const handleClose = () => {
    setIsOpen(false);
    markAllAsRead();
  };

  return (
    <div className="relative" ref={popoverRef}>
      <div onClick={() => setIsOpen(!isOpen)} className="cursor-pointer">
        {trigger}
      </div>

      {isOpen && <div className="absolute right-0 mt-2 z-50">{children}</div>}
    </div>
  );
}

NotificationPopover.Close = function Close({
  children,
  onClick,
}: {
  children: ReactNode;
  onClick?: () => void;
}) {
  return (
    <div
      onClick={(e) => {
        onClick?.(e);
      }}
    >
      {children}
    </div>
  );
};
